module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [(_vm.toast) ? _c('mu-toast', {
    attrs: {
      "message": _vm.hintMsg,
      "id": "alertline"
    },
    on: {
      "close": _vm.hideToast
    }
  }) : _vm._e(), _vm._v(" "), _c('mu-refresh-control', {
    attrs: {
      "refreshing": _vm.refreshing,
      "trigger": _vm.trigger
    },
    on: {
      "refresh": _vm.refresh
    }
  }), _vm._v(" "), _c('pageTitle', {
    attrs: {
      "title": "我的免房券",
      "showRight": true,
      "rightTitle": "使用规则"
    },
    on: {
      "rightHandler": _vm.open
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "convert"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.couponCode),
      expression: "couponCode"
    }],
    attrs: {
      "type": "text",
      "placeHolder": "请输入您的免房券编号"
    },
    domProps: {
      "value": (_vm.couponCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.couponCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.exchangeFreeVo
    }
  }, [_vm._v("兑换")])]), _vm._v(" "), _c('div', {
    staticClass: "demo-refresh-container"
  }, [_c('div', {
    staticClass: "vouchers"
  }, _vm._l((_vm.freeVochers), function(vo, index) {
    return _c('div', {
      staticClass: "vocherbg",
      on: {
        "click": function($event) {
          return _vm.choose(index)
        }
      }
    }, [_c('div', {
      staticClass: "left"
    }, [_c('div', {
      staticClass: "vochermain valid"
    }, [_vm._v("\n                ￥"), _c('span', {
      staticClass: "num"
    }, [_vm._v(_vm._s(vo.Amount))])])]), _vm._v(" "), _c('div', {
      staticClass: "right"
    }, [_c('div', {
      staticClass: "fCon"
    }, [_c('h4', [_vm._v("免房券")]), _vm._v(" "), _c('span', {
      staticClass: "date"
    }, [_vm._v("有效期至  " + _vm._s(vo.ExpireDate))])]), _vm._v(" "), (vo.Status == "0" && _vm.g_currentOrder.freeVoucherInfo.useNotSee) ? _c('div', {
      staticClass: "fBtn",
      class: {
        'active': vo.selected
      }
    }) : _vm._e()])])
  }), 0)]), _vm._v(" "), _c('loadListTail', {
    attrs: {
      "mainTitle": "邀请好友注册有机会抽免房券哦！",
      "mainIcon": "noVoucher",
      "extendBtn": false,
      "btnText": "去邀请好友",
      "noMore": _vm.loadState.stop,
      "isLoading": _vm.loadState.loading,
      "overZero": _vm.freeVochers.length > 0
    },
    on: {
      "btnHandler": _vm.goInvite
    }
  }), _vm._v(" "), _c('div'), _vm._v(" "), (_vm.loadState.loading) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "0.2rem"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "1.2rem"
    },
    attrs: {
      "src": require("../../../static/LoadingBest.gif")
    }
  })]) : _vm._e(), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.dialog
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "-27px",
      "border-radius": "8px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "background-color": "#27ba60",
      "height": "1.2rem",
      "line-height": "1.2rem",
      "text-align": "center",
      "color": "#ffffff",
      "font-size": "0.36rem",
      "font-weight": "600"
    }
  }, [_vm._v("\n          使用规则\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "1em 2em 3em 2em",
      "color": "#666666",
      "font-size": "0.28rem",
      "line-height": "0.34rem"
    }
  }, [_c('p', [_vm._v("1.免房券适用于所有格美系酒店（格林东方、格美、格雅、格菲、格林豪泰、格林联盟、青皮树、贝壳），不适用于促销类房型；")]), _vm._v(" "), _c('p', [_vm._v("2.使用免房券可当天预订，每个订单仅限一间一晚；")]), _vm._v(" "), _c('p', [_vm._v("3.免房券面额有200元、300元，可累计使用，如门市价350元，可使用2张200元免房券进行预订，余额不找零不兑现；")]), _vm._v(" "), _c('p', [_vm._v("4.预订方式同普通订房的操作步骤，只需在提交订单时勾选“使用免房券抵扣”，并填写实际入住人的姓名；")]), _vm._v(" "), _c('p', [_vm._v("5.免房券设有有效期，请在此之前完成预订及入住，具体有效期限请至“会员中心—我的免房券”查询，过期无效；")]), _vm._v(" "), _c('p', [_vm._v("6.免房券订单最晚取消时间为入住日18点，超时取消或未入住均无法退还免房券；")]), _vm._v(" "), _c('p', [_vm._v("7.免房券订单退房时间为中午12点，不赠送早餐，不累计K币，不与其他优惠同享。")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-edf9a958!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/wallet/freeVouchers.vue
// module id = 1610
// module chunks = 18